import React from 'react';

export default class Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToDeliverEveryTime');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMaintainMomentum')}
                                                        className="link_color task button-link-redirect">How to maintain momentum</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToPrioritiseTasksReadyForAction')}
                                                        className="link_color task button-link-redirect">How to prioritise tasks
                                                        ready for action</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDirectPeople')}
                                                        className="link_color task button-link-redirect">How to direct people</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToTakeControl')}
                                                        className="link_color task button-link-redirect">How to take control</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToCopeWithSetbacks')}
                                                        className="link_color task button-link-redirect">How to cope with
                                                        setbacks</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToWinAndManageResources')}
                                                        className="link_color task button-link-redirect">How to win and manage
                                                        resources</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDelegate')}
                                                        className="link_color task button-link-redirect">How to delegate</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToEngageOthersToDeliver')}
                                                        className="link_color task button-link-redirect">How to engage others to
                                                        deliver.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Tversky,
                                                    A. &amp; Kahneman, D. (1974). Judgement under uncertainty:
                                                    Heuristics and biases.
                                                    <span
                                                        className="subtiltereg"> Science,  185,</span> 1124-1131
                                                </p></li>
                                                <li><p className="further_info_content"> Myers, D. (1996).
                                                    <span
                                                        className="subtiltereg"> Social Psychology.</span> McGraw-Hill,
                                                    New York.</p></li>
                                                <li><p className="further_info_content"> Markman,
                                                    K. &amp; Guenther, C. (2007). Psychological momentum:
                                                    Intuitive physics and naïve beliefs.
                                                    <span className="subtiltereg"> Personality and Social Psychology Bulletin,</span> 33,
                                                    800-812.</p></li>
                                                <li><p className="further_info_content"> Hewlett Packard. (2005,
                                                    April).
                                                    <span className="subtiltereg">Abuse of technology can reduce UK workers’ intelligence: HP calls for
more appropriate use of always-one technology to improve productivity.</span></p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}